import { Model as p } from "../../../model.js";
class x extends p {
  constructor(t, s, e, i, r, h, o, a, n, l, m, d, c) {
    super(), this.country = t, this.email = s, this.externalId = e, this.firstName = i, this.gender = r, this.locale = h, this.name = o, this.phone = a, this.surname = n, this.postalCode = m, this.birthdate = d, this.avatar = c, this.marketingPermissions = l;
  }
}
export {
  x as ProfileModel
};
//# sourceMappingURL=profile.model.js.map
